module.exports = __webpack_public_path__ + "913c8eeba8d2d78cbb490f4672ca05bb.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/fi-2006.png
// module id = 519
// module chunks = 0